import { useHttp } from "../http/useHttp";
import { useAxiosQuery } from "../http/useAxiosQuery";
import { paths } from "../generated-types";
import { transformContract, IDashboardContract, IContractResponse } from "./useContracts";

type ContractDetailsOperation = paths["/dashboard/contracts/{contract_shared_uuid}"]["post"];
type ContractDetailsPath = ContractDetailsOperation["parameters"]["path"];
export type IContractDetailsResponse =
  ContractDetailsOperation["responses"][200]["content"]["application/json"];
export type IContractBlock = NonNullable<IContractDetailsResponse["blocks"]>[number];
export type IReceiveMethod = NonNullable<IContractDetailsResponse["receive_method"]>;
export type DataSelectorInput = NonNullable<IContractDetailsResponse["selectors"]>[number];
export type ReaderDescription = NonNullable<IContractDetailsResponse["data_sources"]>[number];
export type DataSelectorDisplay = NonNullable<IContractDetailsResponse["selectors"]>[number];
export type IDashboardContractDetails = IDashboardContract & IContractDetailsResponse;
export type UseContractDetailsInput = {
  id: ContractDetailsPath["contract_shared_uuid"] | undefined;
};

function toContractSummary(contract: IContractDetailsResponse): IContractResponse {
  return {
    ...contract,
    id: 0,
    service_provider_contract_names: [],
  };
}

function transform(contract: IContractDetailsResponse): IDashboardContractDetails {
  return {
    ...contract,
    ...transformContract(toContractSummary(contract)),
  };
}

export const useContractDetails = (input?: UseContractDetailsInput) => {
  const { client } = useHttp();

  const queryKey = ["contracts-details", input];

  const { status, isPending, isFetching, data, error, refetch } =
    useAxiosQuery<IContractDetailsResponse>({
      queryKey,
      queryFn: ({ signal }) => client.post(`/contracts/${input?.id}`, undefined, { signal }),
      enabled: Boolean(input && input.id),
    });

  return {
    contract: data ? transform(data.data) : null,
    status,
    isPending,
    isFetching,
    error,
    refetch,
    queryKey,
  };
};

export type UseContractDetailsReturn = ReturnType<typeof useContractDetails>;
